import React from 'react';
import {
    Box
} from '@mui/material';

const DraggableRow = ({ row, children, onDragStart }) => (
    <Box
        draggable
        onDragStart={onDragStart}
        sx={{
            border: '1px dashed #aaa',
            borderRadius: 1,
            p: 1.25,      // היה 3
            my: 1,        // פחות רווח
            backgroundColor: '#fdfdfd',
            cursor: 'grab',
            transition: 'background-color 0.2s',
            '&:hover': {
              backgroundColor: '#fff3cd',
            },
          }}
    >
        {children}
    </Box>
);

export default DraggableRow